import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: { margin: '0', marginTop: '20vh', marginBottom: '30vh' },
    logo: {
      display: 'block',
      margin: 'auto',
      width: '9rem'
    }
  });

class IconDisplay extends React.Component<IIconDisplayProps> {
  public render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div>
          <img src={this.props.logo} alt="" className={classes.logo} />
        </div>
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Typography variant="h5">{this.props.message}</Typography>
        </div>
      </div>
    );
  }
}
interface IIconDisplayOwnProps extends WithStyles<typeof styles> {
  logo: any;
  message: string;
}
type IIconDisplayProps = IIconDisplayOwnProps;
export default withStyles(styles)(IconDisplay);
